import { render } from "./UserDetailedTicketView.vue?vue&type=template&id=be54f24e"
import script from "./UserDetailedTicketView.vue?vue&type=script&lang=js"
export * from "./UserDetailedTicketView.vue?vue&type=script&lang=js"

import "./UserDetailedTicketView.vue?vue&type=style&index=0&id=be54f24e&lang=scss"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__